import React, { useState, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { TextLink } from "@vds/buttons";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Body, Micro } from "@vds/typography";
import styled from "styled-components";

const ProtectionLegalDetails = ({ ...props }) => {
  const { t } = useTranslation(["pdp"], { useSuspense: true });
  const [showModal, setShowModal] = useState(false);
  const aemContent = t("device-pdp.pdpProtectionContent.legalDetails", {
    returnObjects: true,
  });
  return (
    <LegalContainer>
      <Body bold size="large">
        {aemContent?.title}
      </Body>
      {!!aemContent?.detailItems?.length &&
        aemContent.detailItems.map((i) => (
          <Micro>
            <DetailItem
              dangerouslySetInnerHTML={{
                __html: i,
              }}
            />
          </Micro>
        ))}
      <div>
        <TextLink
          type="standAlone"
          size="small"
          onClick={(e) => {
            setShowModal(true);
          }}
        >
          {aemContent?.linkText}
        </TextLink>
      </div>
      {!!showModal && (
        <DPModal
          className="iframeModel"
          contentContainer={"DPModalContainer"}
          fullScreenDialog={false}
          disableOutsideClick={true}
          opened={showModal}
          onOpenedChange={setShowModal}
        >
          <DPModalBody>
            <iframe
              className="iframeBody"
              width={"100%"}
              height={"100%"}
              src={t(
                "device-pdp.pdpProtectionContent.important_things_to_know_url",
                { ns: "pdp" }
              )}
              title="Device Protection Information"
            ></iframe>
          </DPModalBody>
        </DPModal>
      )}
    </LegalContainer>
  );
};

const LegalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  max-width: 808px;
`;

const DetailItem = styled.span`
  sup {
    font-size: 0.4rem;
    vertical-align: super;
    line-height: 0;
  }
`;

export const DPModal = styled(Modal)`
  height: 100%;
  width: 90%;
  #DPModalContainer {
    padding: 0;
    height: 100%;
    span {
      height: 100%;
    }
  }
`;

export const DPModalBody = styled(ModalBody)`
  padding: 0;
  outline: none !important;
  height: 100%;
  iframe {
    border: none;
    min-height: 250px !important;
    overflow-y: auto;
    height: 100%;
    width: 100%;
  }
`;

const withSuspense = (Component) => {
  return function (props) {
    return (
      <Suspense fallback={<></>}>
        <Component {...props} />
      </Suspense>
    );
  };
};

export default withSuspense(ProtectionLegalDetails);
